import Image from '~/shared/Image';
import React, { useEffect, useState } from 'react';
import { Box, HStack, Pressable } from 'native-base';
import { resizedUrl, useTheme } from '@springbig/shared';

export type ImagesGalleryProps = {
    imagesProp: ImagesProp[];
    width: string;
};

interface ImagesProp {
    id: number;
    label: string;
    thumb: string;
    url: string;
}

const CompactImagesGallery = ({
    imagesProp,
    width,
}: ImagesGalleryProps) => {

    const {
        radius_md,
    } = useTheme();

    const [images, setImages] =
        useState<ImagesProp[] | null>(null);

    const [firstImage, setFirstImage] =
        useState<number | undefined | null>(null);

    useEffect(() => {

        setImages(imagesProp);
        setFirstImage(imagesProp[0]?.id);
    }, []);

    const selectImage = (id: number): void => {

        if (!images) {
            return;
        }

        const selectedImageIndex = images?.findIndex(image => image.id === id);

        if (selectedImageIndex !== -1) {
            const updatedImages = [
                images[selectedImageIndex],
                ...images.slice(0, selectedImageIndex),
                ...images.slice(selectedImageIndex + 1)
            ];

            setImages(updatedImages);
            setFirstImage(updatedImages[0]?.id);
        }
    };

    const _width = parseFloat(width);

    return (
        images && (
            // cancels out Card's padding
            <Box mt={-4} ml={-4} position={'relative'}>
                <Image
                    w={_width / 2}
                    h={_width / 2}
                    uri={resizedUrl(images[0].url, _width / 2, _width / 2)}
                    position={'fixed'}
                    opacity={.3}
                    borderTopLeftRadius={radius_md}
                />
                <Image
                    w={_width / 2}
                    h={_width / 2}
                    uri={resizedUrl(images[0].url, _width / 2, _width / 2)}
                    position={'fixed'}
                    marginLeft={_width / 2}
                    opacity={.3}
                    borderTopRightRadius={radius_md}
                />
                { images.map((image, index) => {

                    if (firstImage === image.id) {
                        return (
                            <Pressable onPress={() => selectImage(image.id)} key={index}>
                                <Image
                                    key={image.id}
                                    w={_width / 2}
                                    h={_width / 2}
                                    marginLeft={images.length === 1 ? _width / 4 : 0}
                                    uri={resizedUrl(image.url, _width / 2, _width / 2)}
                                />
                            </Pressable>
                        );
                    }
                })}

                <HStack
                    flexWrap={'wrap'}
                    position={'absolute'}
                    w={_width / 2}
                    left={_width / 2}
                >
                    { images.map((image, index) => {

                        if (firstImage !== image.id) {
                            return (
                                <Pressable onPress={() => selectImage(image.id)} key={index}>
                                    <Image
                                        key={image.id}
                                        w={_width / 4}
                                        h={_width / 4}
                                        uri={resizedUrl(image.url, _width / 4, _width / 4)}
                                    />
                                </Pressable>
                            );
                        }
                    })}
                </HStack>
            </Box>
        )
    );
};

export default CompactImagesGallery;
